import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const DATE_ONLY_FORMAT = 'YYYY-MM-DD';
const DISPLAY_DATE_FORMAT = 'DD.MM.YYYY';

export const formatExpenseInvoiceDate = (value: string | null | undefined): string => {
  if (!value) {
    return '-';
  }

  const dateOnly = dayjs(value, DATE_ONLY_FORMAT, true);
  if (dateOnly.isValid()) {
    return dateOnly.format(DISPLAY_DATE_FORMAT);
  }

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(DISPLAY_DATE_FORMAT) : '-';
};
